<template>
  <div ref="SubContentContainer" class="transparent">
    <h1 v-if="$props.title" class="sub-content-container-title text-center">{{ $props.title }}</h1>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'SubContentContainer',
  props: {
    /*
     * @property - title
     * Defines title inside this component if is defined
     */
    title: {
      type: String,
      default: null
    }
  }
};
</script>
